import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/hooks/useTheme";
import { CartProvider } from "@/context/CartContext";
import { siteConfig } from "@/config/siteConfig";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import Contact from "./pages/Contact";
import LongDistanceTravel from "./pages/LongDistanceTravel";
import OnlineBooking from "./pages/OnlineBooking";
import LuggageServices from "./pages/LuggageServices";
import BusHire from "./pages/BusHire";
import RoutesMap from "./pages/RoutesMap";
import { FloatingWhatsAppIcon } from "./components/FloatingWhatsAppIcon";
import { FloatingCart } from "./components/FloatingCart";
import { FloatingProceedButton } from "./components/FloatingProceedButton";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <CartProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/long-distance-travel" element={<LongDistanceTravel />} />
              <Route path="/online-booking" element={<OnlineBooking />} />
              {siteConfig.luggageServicesEnabled && <Route path="/luggage-services" element={<LuggageServices />} />}
              <Route path="/bus-hire" element={<BusHire />} />
              <Route path="/routes" element={<RoutesMap />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <FloatingWhatsAppIcon />
            <FloatingCart />
            <FloatingProceedButton />
          </BrowserRouter>
        </TooltipProvider>
      </CartProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
